/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientCredentials
 */
export interface ClientCredentials {
    /**
     * 
     * @type {string}
     * @memberof ClientCredentials
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCredentials
     */
    secret: string;
}

/**
 * Check if a given object implements the ClientCredentials interface.
 */
export function instanceOfClientCredentials(value: object): value is ClientCredentials {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('secret' in value) || value['secret'] === undefined) return false;
    return true;
}

export function ClientCredentialsFromJSON(json: any): ClientCredentials {
    return ClientCredentialsFromJSONTyped(json, false);
}

export function ClientCredentialsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCredentials {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'secret': json['secret'],
    };
}

export function ClientCredentialsToJSON(json: any): ClientCredentials {
    return ClientCredentialsToJSONTyped(json, false);
}

export function ClientCredentialsToJSONTyped(value?: ClientCredentials | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'secret': value['secret'],
    };
}

